import { QualtricsResponseHandler } from "../survey";
import { type ValidationResult } from "./distroValidator";

/**
 * Checks for duplicate survey ids across Qualtrics response handlers.
 */
export const noDuplicateQualtricsSurveyIdsRule = (qualtricsResponseHandler: Readonly<QualtricsResponseHandler>, state: Record<string, any>) => {
  const uniqueQualtricsSurveyIds: Record<string, {
    count: number,
    results: ValidationResult["result"][]
  }> = state.uniqueQualtricsSurveyIds ??= {};

  let result = { passed: true };
  const surveyIdState = uniqueQualtricsSurveyIds[qualtricsResponseHandler.surveyId];
  if (surveyIdState) {
    surveyIdState.count++;
    surveyIdState.results.push(result);

    // Modify the current result and all prior results for this title
    surveyIdState.results.forEach(r => {
      r.passed = false;
      r.message = `Survey id "${qualtricsResponseHandler.surveyId}" is used in ${surveyIdState.count} Qualtrics response handlers`;
    });

    return result;
  } else {
    state.uniqueQualtricsSurveyIds[qualtricsResponseHandler.surveyId] = { count: 1, results: [result] };
    return result;
  }
}
